import { EventEmitter } from 'events';

export const errorEmitter = new EventEmitter();
